import React from "react";
import logo from "../../template/images/finlabs-logo.png";

function Header() {
  return (
    <>
      <div className="header">
        <div className="container">
          <div className="nav_bar">
            <div className="brand_logo">
              <img src={logo} alt className="brand_image img-fluid" />
            </div>
            {window.location.pathname == "/RiskAnalyser" ? (
              <div className="contact">
                <a
                  href="https://finlabsindia.org/contact-us"
                  className="contact_btn"
                >
                  <i className="fa fa-solid fa-phone me-1" /> Contact Us
                </a>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
